import { render, staticRenderFns } from "./NavFooterRoutes.vue?vue&type=template&id=30015c4a&scoped=true"
import script from "./NavFooterRoutes.vue?vue&type=script&lang=js"
export * from "./NavFooterRoutes.vue?vue&type=script&lang=js"
import style0 from "./NavFooterRoutes.vue?vue&type=style&index=0&id=30015c4a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30015c4a",
  null
  
)

export default component.exports